import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'z-logo',
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {}
